var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card3",staticStyle:{"width":"50%","margin-left":"30%"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c63e6fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/box3.vue
// module id = null
// module chunks = 